import type { GuaranteeApiDatasource } from '../datasources/guarantee-api.datasource';
import type {
  CampaignOfferRef,
  GuaranteeCampaignDetail,
  GuaranteeCampaignListItem,
  GuaranteeRule,
  Paginated,
} from '../../domain/entities/guarantee.entity';

export class GuaranteeRepositoryImpl {
  private api: GuaranteeApiDatasource;

  constructor(api: GuaranteeApiDatasource) {
    this.api = api;
  }

  listCampaigns(input: {
    page: number;
    perPage: number;
  }): Promise<Paginated<GuaranteeCampaignListItem>> {
    return this.api.listCampaigns(input);
  }

  getCampaign(id: string): Promise<GuaranteeCampaignDetail> {
    return this.api.getCampaign(id);
  }

  createCampaign(input: {
    name: string;
    rule: GuaranteeRule;
  }): Promise<GuaranteeCampaignDetail> {
    return this.api.createCampaign(input);
  }

  renameCampaign(id: string, name: string): Promise<void> {
    return this.api.renameCampaign(id, name);
  }

  addOffer(id: string, offer: CampaignOfferRef): Promise<void> {
    return this.api.addOffer(id, offer);
  }

  removeOffer(id: string, offer: CampaignOfferRef): Promise<void> {
    return this.api.removeOffer(id, offer);
  }

  updateRule(id: string, rule: GuaranteeRule): Promise<void> {
    return this.api.updateRule(id, rule);
  }
}
